import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {initialize, reduxForm, Field} from 'redux-form';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {Link} from 'react-router';

import * as types from '../types/index';

import * as authActions from '../actions/auth';
import FlashMessage from '../components/FlashMessage';
import TextInput from '../components/Form/TextInput';
import Footer, {bindPaths, PATHS} from '../components/Footer';
import validate from '../validators/forms/reset-password';
import AppBlock from '../components/AppBlock';
import Title from '../components/Form/Title';
import TextPage from './TextPage';

const FORM_NAME = 'resetPassword-form';

class AuthResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resendTimeout: 0
    };

    this.identifierField =
      props.xl.isUsernameEmail || props.xl.proxy.resetPassword ? 'email' : 'username';

    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    const initialFormData = {
      [this.identifierField]: this.props.auth.reset[this.identifierField]
    };

    this.props.dispatch(initialize(FORM_NAME, initialFormData));
    this.resetTimer();
  }

  componentWillUnmount() {
    clearInterval(this.state.resendTimeout);
  }

  handleChange(event) {
    if (event.target.name === 'email') {
      authActions.setEmail(this.props.dispatch, event.target.value);
    }
    if (event.target.name === 'username') {
      authActions.setUsername(this.props.dispatch, event.target.value);
    }
  }

  resetTimer() {
    const intervalId = setInterval(() => {
      const {auth, dispatch} = this.props;

      if (auth.reset.timer > 0) {
        dispatch({type: types.RESET_SET_TIMER, count: auth.reset.timer - 1});
      } else {
        clearInterval(this.state.resendTimeout);
      }
    }, 1000);
    this.setState({resendTimeout: intervalId});
  }

  handleFormSubmit(values) {
    const {xl, dispatch, location} = this.props;

    authActions.resetAsync(dispatch, values, location.query, xl).then(() => {
      this.resetTimer();
    });
  }

  successMessage() {
    const {intl, auth} = this.props;
    return (
      <div className="block-content">
        <div className="content-message">
          <div className="message">
            {intl.messages['auth-reset.complete']} <br /> {auth.reset.email}
          </div>

          {auth.reset.timer === 0 ? (
            <a
              className="form-button button-link button-link_active"
              onClick={this.handleFormSubmit.bind(this, {email: auth.reset.email})}
            >
              {intl.messages['auth-reset.resend']}
            </a>
          ) : (
            <div className="form-button button-link">
              {intl.messages['auth-reset.resend']} ({auth.reset.timer})
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const {intl, auth, handleSubmit, location} = this.props;

    return (
      <Fragment>
        {auth.reset.isResetting === false ? (
          <Fragment>
            <AppBlock>
              <Title
                title={intl.messages['auth-reset.title']}
                forceShow
                backLink={
                  <Link className="back-link" to={{pathname: '/', search: location.search}}>
                    {intl.messages['app.back']}
                  </Link>
                }
              />

              <div className="block-content">
                {auth.reset.error !== null && (
                  <FlashMessage type="error" message={auth.reset.error} />
                )}

                <form onSubmit={handleSubmit(this.handleFormSubmit)}>
                  <Field
                    component={TextInput}
                    name={this.identifierField}
                    type="text"
                    label={intl.messages[`form.${this.identifierField}`]}
                    required="true"
                    icon="user"
                    disabled={auth.reset.loading}
                    onChange={this.handleChange}
                  />

                  <button
                    type="submit"
                    className="form-button button-with-bg"
                    disabled={auth.reset.loading}
                  >
                    {auth.reset.loading
                      ? intl.messages['form.loading']
                      : intl.messages['auth-reset.submit']}
                  </button>
                </form>
              </div>
            </AppBlock>

            <Footer links={bindPaths(PATHS.CREATE_ACCOUNT)} />
          </Fragment>
        ) : (
          <TextPage
            content={this.successMessage()}
            title={intl.messages['auth-reset.title']}
            backLinkParams={{pathname: '/', search: this.props.location.search}}
          />
        )}
      </Fragment>
    );
  }
}

AuthResetPassword.propTypes = {
  auth: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  xl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    ...state,
    ...validate(state.xl.isUsernameEmail),
    form: FORM_NAME
  };
}

export default injectIntl(connect(mapStateToProps)(reduxForm()(AuthResetPassword)));



// WEBPACK FOOTER //
// ./pages/ResetPassword.jsx